import * as selector from './selectors';

export const officerSelector = selector;
export * from './actions';
export { default as reducer } from './reducer';
